import * as React from 'react';

const PulseTheDotSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" {...props}>
        <circle
            id="pulse-the-dot_svg__eds-icon--halo"
            opacity={0.5}
            cx="50%"
            cy="50%"
            r={4}
            fill="#F05537"
        />
        <circle cx="50%" cy="50%" r={4} fill="#F05537" />
    </svg>
);

PulseTheDotSvg.displayName = 'PulseTheDotSvg';
export default PulseTheDotSvg;
